export function sortTemplates(templateArr: any[], sortValue: string) {
  let sortKey = '';
  let isAsc = false;
  if (sortValue === 'titleasc') {
    sortKey = 'Title';
    isAsc = true;
  } else if (sortValue === 'titledesc') {
    sortKey = 'Title';
    isAsc = false;
  } else if (sortValue === 'dateasc') {
    sortKey = 'published_at';
    isAsc = true;
  } else if (sortValue === 'datedesc') {
    sortKey = 'published_at';
    isAsc = false;
  } else {
    // relevance, return templateArr as it is
    return templateArr;
  }
  if (isAsc) {
    return templateArr.sort((a, b) => {
      const x = a[sortKey];
      const y = b[sortKey];
      return x < y ? -1 : x > y ? 1 : 0;
    });
  }
  return templateArr.sort((a, b) => {
    const x = a[sortKey];
    const y = b[sortKey];
    return x > y ? -1 : x < y ? 1 : 0;
  });
}
